/**
 * Whether the sign-in sheet is open, and a message waiting to be shown in it. Pulled out of
 * `screens/SignInScreen.tsx` so other code can pop the sheet up on its own without importing
 * a screen.
 */
import type { SignInResult } from './sync.ts';

let open = false;
let pendingResult: SignInResult | null = null;
const listeners = new Set<(value: boolean) => void>();

export function openSignIn(): void {
  open = true;
  for (const listener of listeners) listener(open);
}

/** Opens the sheet with a message already showing, e.g. the session-ended notice. */
export function openSignInWithMessage(message: string): void {
  pendingResult = { ok: false, message };
  openSignIn();
}

export function closeSignIn(): void {
  open = false;
  for (const listener of listeners) listener(open);
}

export function isSignInOpen(): boolean {
  return open;
}

/** Reads and clears the pending message, so it is shown once. */
export function takePendingResult(): SignInResult | null {
  const result = pendingResult;
  pendingResult = null;
  return result;
}

export function onSignInOpenChange(cb: (value: boolean) => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
